module.exports = __webpack_public_path__ + "img/Six.47a4f203.jpg";